import $ from 'jquery';

$('.business-opportunities-play').click(function () {
    const $background = $('.business-opportunities-background');
    const $video = $('.business-opportunities-video');
    const video = $video[0];
    $video.show();
    $background.hide();
    video.volume = 0.1;
    video.play();
});
